module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
(function(fox, $) {
	"use strict";
	fox.registerWidget('RefLink', {

		configure: function(options) {
			
			this.registerOptions('', {
				autoRender: true,
				container: '.ref-link-wrapper',
				template: 'sidebar_refLink',
				btnSelector: '.fox-cb-copy'
			});

			this.callParent('configure', arguments);
		},

		running: function (argument) {
			this.callParent('running', arguments);
		},

		deactivate: function (argument) {
			this.clipboard.destroy();

			this.callParent('deactivate', arguments);
		},

		addedToDom: function (argument) {
			this.clipboard = new ClipboardJS(this.getOption('btnSelector'));

			this.clipboard.on('success', fox.bind(this._onCopySuccess, this));
			this.clipboard.on('error', fox.bind(this._onCopyError, this));

			this.applySliding();

			window.setTimeout(fox.bind(function (argument) {
				this.applyTooltip();
			}, this), 500);
		},

		_onCopySuccess: function (e) {
			//console.warn('success', e);

			fox.dom.addClass('copied', this.dom1('.action-wrapper'));

			this.window.setTimeout(fox.bind(function (argument) {
				if (this.isActive()) {
					fox.dom.removeClass('copied', this.dom1('.action-wrapper'));
				}
			}, this), 3000);
		},

		_onCopyError: function (e) {
			console.warn('error', e);
		},

		applyTooltip: function (argument) {
			if ($(this.element).tooltip('instance') === undefined) {
				$(this.element).tooltip({
					position: {
						my: 'left-53 bottom-25',
						at: 'left bottom',
						collision: 'flipfit',
						using: function (pos, feedb) {
							$(this).css(pos).addClass(feedb.vertical).addClass(feedb.horizontal);
						}
					},
					tooltipClass: 'gui-tooltip-type-1',
					items: '.gui-tooltip-link',
					content: function () {
						return $(this).find('.tt-content').html();
					},
					//hide:{delay: 800}
				});
			}
		},

		applySliding: function () {
			var p = $(this.dom1('.link-container'));
			var el = p.find('[name="ref-link"]');

			if (el.val().length >= 25) {
				p.addClass('wide');
			}

			if (el.val().length >= 28) {
				p.on('mouseenter', fox.bind(this._handleSliding, this));
				p.on('mouseleave', fox.bind(this._handleSlidingStop, this));
			}

			p.on('click', fox.bind(this._handleFocus, this));
		},

		_handleFocus: function (e) {
			e.toElement.select();
		},

		_handleSliding: function () {
			var delta;
			var time;

			var velo 	=	80; // pix/sec
			var elem	= 	$(this.dom1('.link-container'));
			var title	= 	$(elem).find('.link-wrapper');
			var layoutBox 		= $(elem).width();
			var layoutTitle 	= $(elem).find('span').width();

			delta = layoutBox - layoutTitle;
			time = delta/velo*(-1000);
			time = delta/velo*(-1) > 1 ? time : 500;

			$(title).animate({"margin-left": delta-10 + "px"}, time);
		},

		_handleSlidingStop: function (argument) {
			$(this.dom1('.link-container .link-wrapper')).stop(true).animate({"margin-left": "0px"}, 500);
		}


	});
})(fox, fox.jQuery);

 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/admin/common/frame/widget/refLink.js
// module id = 349
// module chunks = 2